import { BootcampSlugData } from "@/types/bootcamp-slug";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../ui/Collapsible";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

const Summary = ({
  isToken,
  tokenAmount,
  price,
  addPlan,
  bootcamp,
  couponDiscount,
  isDiscounted,
}: {
  price: number;
  isToken: boolean;
  addPlan: boolean;
  tokenAmount?: number;
  bootcamp: any;
  couponDiscount?: number;
  isDiscounted?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isTokenApplied = isToken && tokenAmount;
  const isDiscountApplied = isDiscounted && price;
  return (
    <Collapsible className="space-y-2" open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger className="border-none p-0 text-blue-900 text-lg">
        Summary{" "}
        <ChevronRight className={cn("h-4 w-4", isOpen ? "rotate-90" : "")} />
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-2">
        <div className="flex justify-between">
          <p>Actual Price</p>
          <p className="font-semibold">
            {Number(bootcamp?.price).toLocaleString("en-IN", {
              style: "currency",
              currency: "INR",
              minimumFractionDigits: 0,
            })}
          </p>
        </div>
        {addPlan && (
          <div className="flex justify-between">
            <p>Astrolearn Gold</p>
            <p className="font-semibold">
              {Number(499).toLocaleString("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              })}
            </p>
          </div>
        )}
        <div className="flex justify-between">
          <p>Offer Discount</p>
          <p className="font-semibold">
            -{" "}
            {Number(
              bootcamp?.price -
                bootcamp?.discountedPrice +
                (isDiscounted ? bootcamp?.discountedPrice - price : 0)
            ).toLocaleString("en-IN", {
              style: "currency",
              currency: "INR",
              minimumFractionDigits: 0,
            })}
          </p>
        </div>
        {isDiscountApplied ? (
          <div className="flex justify-between">
            <p>Extra Discount</p>
            <p className="font-semibold">
              -{" "}
              {Number(bootcamp.discountedPrice - price).toLocaleString(
                "en-IN",
                {
                  style: "currency",
                  currency: "INR",
                  minimumFractionDigits: 0,
                }
              )}
            </p>
          </div>
        ) : null}
        {couponDiscount ? (
          <div className="flex justify-between">
            <p>Coupon Discount</p>
            <p className="font-semibold">
              -{" "}
              {Number(couponDiscount).toLocaleString("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              })}
            </p>
          </div>
        ) : null}
      </CollapsibleContent>
      <hr />
      <div className="flex justify-between">
        <p>Savings</p>
        <p className="font-semibold">
          {Number(
            bootcamp?.price -
              bootcamp?.discountedPrice +
              (couponDiscount! ? couponDiscount : 0) +
              (isDiscountApplied ? bootcamp?.discountedPrice - price : 0)
          ).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
          })}
        </p>
      </div>
      <hr />
      <div className="flex justify-between text-green-600">
        <p>Final Price</p>
        <p className="font-semibold">
          {Number(
            isDiscountApplied
              ? price -
                  (couponDiscount ? couponDiscount : 0) +
                  ((addPlan && !isToken) ? 499 : 0)
              : bootcamp.discountedPrice -
                  (couponDiscount ? couponDiscount : 0) +
                  ((addPlan && !isToken) ? 499 : 0)
          ).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
          })}
        </p>
      </div>
      {isTokenApplied ? (
        <div className="flex justify-between text-green-600">
          <p>Token Amount</p>
          <p className="font-semibold">
            {Number(price + ((addPlan && !isToken) ? 499 : 0)).toLocaleString("en-IN", {
              style: "currency",
              currency: "INR",
              minimumFractionDigits: 0,
            })}
          </p>
        </div>
      ) : null}
    </Collapsible>
  );
};

export default Summary;
